/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Microsoft_Tenant_SavedInputs */



/**
* | output |
* | --- |
* | "Microsoft sign-in settings saved" |
*
* @param {Microsoft_Tenant_SavedInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const microsoft_tenant_saved = /** @type {((inputs?: Microsoft_Tenant_SavedInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Microsoft_Tenant_SavedInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ ("Einstellungen für die Microsoft-Anmeldung gespeichert")
	return /** @type {LocalizedString} */ ("Microsoft sign-in settings saved")
});